module.exports = __webpack_public_path__ + "static/media/pacoteJPAREC.72a152a0.jpg";